<template>
  <!--  <div  class="vertical-group-wrapper">-->
  <div :style="getBtnStyle" class="btn-group-vertical left-group">
    <button
      v-for="preset in presetsForTag[tag]"
      :key="preset"
      type="button"
      class="btn btn-light btn-tag-drop"
      @click="emitPresetTrigger(preset.alias, tag)"
    >
      {{ preset.title }}
    </button>
  </div>
  <!--  </div>-->
</template>

<script>
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "TagsDropdownItem",
  props: {
    btnColors: {
      type: Object
    },
    multipleColumn: {
      type: Boolean
    },
    tag: {
      type: String
    },
    customColor: {
      type: String
    }
  },
  data() {
    return {
      presetsForTag: {
        ln: [
          { title: "T", alias: "TODAY" },
          { title: "Y", alias: "YESTERDAY" },
          { title: "LW", alias: "L_WEEK" },
          { title: "TM", alias: "MONTH" },
          { title: "LM", alias: "LAST_MONTH" },
          { title: "ALL", alias: "ALL" },
          { title: "CAL", alias: null }
        ],
        lda: [
          { title: "T", alias: "TODAY" },
          { title: "Y", alias: "YESTERDAY" },
          { title: "LW", alias: "L_WEEK" },
          { title: "TM", alias: "MONTH" },
          { title: "LM", alias: "LAST_MONTH" },
          { title: "CAL", alias: null }
        ]
      }
    };
  },
  methods: {
    showSingleNaAll() {
      if (
        this.multipleColumn &&
        this.CheckUserPermission([1, 2, 3, 4, 12]) &&
        this.tag === "na"
      ) {
        return true;
      } else {
        return false;
      }
      //    multipleColumn && CheckUserPermission([1, 2, 3, 4, 7, 12]) && tag === 'na'
    },
    emitPresetTrigger(preset, tag) {
      this.$emit("presetTrigger", { preset, tag });
    },
    emitPresetTriggerFuture(preset) {
      this.$emit("presetTriggerFuture", preset);
    },
    emitPresetTriggerNaAll(preset) {
      this.$emit("presetTriggerNaAll", preset);
    }
  },
  mixins: [UsersPermissionCheck],
  computed: {
    getBtnStyle() {
      if (this.customColor) {
        return {
          "--bg-color": this.customColor,
          "--color": this.btnColors.color
        };
      } else {
        return {
          "--bg-color": this.btnColors.backgroundColor,
          "--color": this.btnColors.color
        };
      }
    }
  },
  mounted() {
    // this.getBtnStyle
  }
};
</script>

<style scoped lang="scss">
$bgColor: var(--bg-color);
$color: var(--color);
.btn-tag-drop {
  background-color: $bgColor;
  color: $color;
  font-size: 10px;
  padding: 3px 0px;
  margin-bottom: 1px;
}

.btn-tag-drop:hover {
  //opacity: 0.9;
  filter: brightness(95%);
}

.vertical-group-wrapper {
  display: flex;
}

.left-group,
.right-group {
  flex: 1;
  max-width: 50% !important;
}

.single-group {
  flex: 1;
  width: 100% !important;
}

/*
    .left-group .btn-tag-drop:last-child {
      //border-radius: 0px 0px 0px 5px !important;
    }
    .left-group .btn-tag-drop:first-child {
      //border-radius: 5px 0px 0px 0px !important;
    }
    .right-group .btn-tag-drop:last-child {
      //border-radius: 0px 0px 5px 5px !important;
    }
    .right-group .btn-tag-drop:first-child {
      //border-radius: 0px 5px 0px 0px !important;
    }
    */
</style>
